import { IVehicleDetails } from '@/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MMVDetails {
    model_id: number;
    model: string;
    car_age?: number;
    color?: string;
    fuel_type: string;
    make?: string;
    variant_id?: string;
    variant_name?: string;
}

interface VehicleInfoState {
    carNumber: string | null;
    vehicleDetails: MMVDetails | null;
    hasSavedVehicle: boolean;
    savedAssets: IVehicleDetails[];
    isLoadingSavedAssets: boolean;
    shouldFetchSavedAssets: boolean;
}

const initialState: VehicleInfoState = {
    carNumber: null,
    vehicleDetails: null,
    hasSavedVehicle: false,
    savedAssets: [],
    isLoadingSavedAssets: false,
    shouldFetchSavedAssets: true,
};

const vehicleInfoSlice = createSlice({
    name: 'savedVehicleData',
    initialState,
    reducers: {
        setVehicleInfo: (
            state,
            action: PayloadAction<
                Omit<
                    VehicleInfoState,
                    | 'savedAssets'
                    | 'isLoadingSavedAssets'
                    | 'shouldFetchSavedAssets'
                >
            >
        ) => {
            state.carNumber = action.payload.carNumber;
            state.vehicleDetails = action.payload.vehicleDetails;
            state.hasSavedVehicle = action.payload.hasSavedVehicle;
        },
        clearVehicleInfo: (state) => {
            state.carNumber = null;
            state.vehicleDetails = null;
            state.hasSavedVehicle = false;
        },
        setSavedAssets: (state, action: PayloadAction<IVehicleDetails[]>) => {
            state.savedAssets = action.payload;
        },
        setIsLoadingSavedAssets: (state, action: PayloadAction<boolean>) => {
            state.isLoadingSavedAssets = action.payload;
        },
        updateSavedAssetCallStatus: (state, action: PayloadAction<boolean>) => {
            state.shouldFetchSavedAssets = action.payload;
        },
    },
});

export const {
    setVehicleInfo,
    clearVehicleInfo,
    setSavedAssets,
    setIsLoadingSavedAssets,
    updateSavedAssetCallStatus,
} = vehicleInfoSlice.actions;

export default vehicleInfoSlice.reducer;

// Selectors
export const selectVehicleInfo = (state: {
    savedVehicleData: VehicleInfoState;
}) => state.savedVehicleData;
export const selectSavedAssets = (state: {
    savedVehicleData: VehicleInfoState;
}) => state.savedVehicleData.savedAssets;
export const selectIsLoadingSavedAssets = (state: {
    savedVehicleData: VehicleInfoState;
}) => state.savedVehicleData.isLoadingSavedAssets;
